import { connect } from 'react-redux';
import Top10Analysis from '../../../views/Library/Top10Analysis/Top10Analysis.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(Top10Analysis);
